import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const DepotIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.342 8.06 12 3.936.658 8.06l.684 1.88L2 9.7V20a1 1 0 0 0 1 1h5v-6h8v6h5a1 1 0 0 0 1-1V9.7l.658.24zM20.074 9 12 6.064 3.926 9H4v10h2v-6h12v6h2V9z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
